import { post } from '../Services/http';
import { ORDER_SUMMARY_RECEIVED } from '../constants';

export const updateOrderSummary = (shippingCost) => (dispatch) => {
  const cost = Number(shippingCost);
  if (isNaN(cost)) {
    console.error('Invalid shipping cost value');
    return;
  }

  return post('/api/checkout/updateOrderSummary', { shippingCost: cost })
    .then((response) => response.json())
    .then((orderSummary) => {
      dispatch(receive(orderSummary));
    })
    .catch((ex) => {
      console.log(ex);
      throw ex;
    });
};

export const receive = (orderSummary) => (dispatch) => {
  return dispatch({
    type: ORDER_SUMMARY_RECEIVED,
    payload: orderSummary,
  });
};
